export default function SelectionBar({ count, onMove, onCopy, onDelete, onClear }) {
  return (
    <div className="selection-bar">
      <span>✓ {count} item{count === 1 ? "" : "s"} selected</span>
      <button className="fm-btn" onClick={onMove}>
        Move to…
      </button>
      <button className="fm-btn" onClick={onCopy}>
        Copy to…
      </button>
      <button className="fm-btn fm-btn-danger" onClick={onDelete}>
        🗑️ Delete
      </button>
      <button className="fm-btn fm-btn-ghost" onClick={onClear}>
        Cancel
      </button>
    </div>
  );
}
